document.querySelectorAll('.emily-sizefinder').forEach((root) => {
  const toggle = root.querySelector('.emily-sizefinder__toggle');
  const panel = root.querySelector('.emily-sizefinder__panel');
  const go = root.querySelector('[data-emily-go]');
  const result = root.querySelector('[data-emily-result]');
  if (!toggle || !panel || !go) return;

  const measureToggle = root.querySelector('[data-emily-measure-toggle]');
  const measureFigure = root.querySelector('[data-emily-measure-figure]');
  if (measureToggle && measureFigure) {
    measureToggle.addEventListener('click', () => {
      const open = measureToggle.getAttribute('aria-expanded') === 'true';
      measureToggle.setAttribute('aria-expanded', String(!open));
      measureFigure.hidden = open;
    });
  }

  toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  });

  const sizeFor = (bust, weight) => {
    // Base on bra band size; nudge up one size when weight runs high for the band.
    // Input is the FULL bust measurement (fullest part, over the bra).
    // Bands derived from the manufacturer garment chart (M-XXL) and extended
    // to the store's S-4XL range: body bust fits roughly garment bust x 2 minus
    // the compression stretch allowance.
    const bands = [[30.5, 'S'], [33, 'M'], [35.5, 'L'], [38.5, 'XL'], [40.5, '2XL'], [99, '3XL']];
    let size = 'L';
    for (const [max, label] of bands) {
      if (bust <= max) { size = label; break; }
      size = label;
    }
    const expected = { S: 125, M: 150, L: 175, XL: 200, '2XL': 225, '3XL': 250 }[size] ?? 200;
    if (weight > expected + 30) {
      const order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];
      size = order[Math.min(order.indexOf(size) + 1, order.length - 1)];
    }
    return size;
  };

  go.addEventListener('click', () => {
    const weight = Number(root.querySelector('[data-emily-weight]').value);
    const bust = Number(root.querySelector('[data-emily-bust]').value);
    if (!bust || bust < 28 || bust > 60) {
      result.textContent = 'Please enter your full bust measurement (28\u201360 in).';
      return;
    }
    const size = sizeFor(bust, weight || 0);
    result.innerHTML = '';
    const chip = document.createElement('strong');
    chip.className = 'emily-sizefinder__size';
    chip.textContent = size;
    result.append('Your Emily size: ', chip);
  });
});
